import {Component, HostListener, Injector, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AppComponent} from 'src/app/app.component';
import {Hotel} from 'src/app/core/viewModel/hotel';
import {DestinoService} from '../../core/services/destino.service';
import {HotelService} from '../../core/services/hotel.service';
import {Meta, Title} from '@angular/platform-browser';
import {BaseComponents} from '../../shared/base-components';
import {TYPE_META} from '../../core/constants/meta_title.constant';

@Component({
    selector: 'app-destions',
    templateUrl: './destinos.component.html',
    styleUrls: ['./destinos.component.sass']
})


export class DestinosComponent extends BaseComponents implements OnInit {

    resultHoteis: any;
    premiumList: Hotel[] = [];

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.handleMobile();
    }

    constructor(
        protected injector: Injector,
        protected titleService: Title,
        protected meta: Meta,
        public destinoService: DestinoService,
        protected router: Router,
        private appComponent: AppComponent,
        public hotelService: HotelService
    ) {
        super(injector);
    }

    async ngOnInit() {
        window.open('https://www.viagensmontreal.com/blog/destinos/destinos-nacionais/', '_top');
        await this.loadDestinos();
        await this.loadHoteisPremium();
        super.ngOnInit();
        this.setMetaTitle(TYPE_META.DESTINOS);
    }

    async loadDestinos() {
        this.appComponent.showOverlay();
        this.resultHoteis = this.destinoService.listaDestinos();
        this.appComponent.hideOverlay();
    }


    async loadHoteisPremium() {
        const result = await this.hotelService.buscaHoteisDestaque(39);
        let data = [];
        if (result) {
            data = result.data;
        }
        this.premiumList = data;
    }


    public irParaDestino(slug) {
        this.router.navigate(['/destinos', slug]);
    }

    navegarParaDetalheHotel(item): void {
        const param = item.codContrato + '_' + item.slug;
        this.router.navigate(['/hoteis/hotel/', param]);
    }
}
